import Swal from "sweetalert2";
import { getCsrfToken } from "../utils/AuthUtils";
import { baseUrl } from "../utils/commonUtils";

$(() => {
    $("#formPasswordRecoverySubmit").on("click", () => {
        sendPasswordRecovery($("#email").val()?.toString() ?? "");
    });
});

function sendPasswordRecovery(email: string) {
    $.ajax({
        url: `${baseUrl}users/forgotPassword.json`,
        data: {
            email: email,
        },
        type: "POST",
        cache: false,
        headers: {
            "X-CSRF-Token": getCsrfToken(),
        },
        dataType: "json",
        success: (json) => {
            if (json) {
                if (json.status === 0) {
                    $("#email").val("");
                    Swal.fire("Succès", json.message, "success");
                } else {
                    Swal.fire("Erreur lors de l'enregistrement", json.message, "error");
                }
            }
        },
        error: (error) => {
            console.error(error);
        },
    });
}
